export default {
  props: {
    resultsComponent: {
      type: String,
      default: 'DataGridResults',
    },
    resultsComponentProps: {
      type: Object,
      default: () => ({}),
    },
    endpoint: {
      type: String,
      required: true,
    },
    infinite: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    include: {
      type: String,
      default: null,
    },
    order: {
      type: String,
      default: null,
    },
    direction: {
      type: String,
      default: 'ASC',
    },
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 15,
    },
    additionalData: {
      type: Object,
      default: () => ({}),
    },
    fetchOnMount: {
      type: Boolean,
      default: true,
    },
    trackHistory: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      results: [],
      meta: {},
      isLoading: false,
      poppingState: false,
      initialState: null,
      skipNextPushState: false,
    };
  },
  computed: {
    appliedPage() {
      if (this.hasProp('page')) {
        return this.page;
      }
      return this.$store.state.grid.page;
    },
    appliedPerPage() {
      if (this.hasProp('perPage')) {
        return this.perPage;
      }
      return this.$store.state.grid.perPage;
    },
    appliedFilters() {
      if (this.hasProp('filters')) {
        return this.filters;
      }
      return this.$store.state.grid.filters;
    },
    appliedOrder() {
      if (this.hasProp('order')) {
        return this.order;
      }
      return this.$store.state.grid.order;
    },
    appliedDirection() {
      if (!this.appliedOrder) {
        return null;
      }
      if (this.hasProp('direction')) {
        return this.direction;
      }
      return this.$store.state.grid.direction;
    },
    data() {
      return {
        page: this.appliedPage,
        perPage: this.appliedPerPage,
        filters: this.appliedFilters,
        order: this.appliedOrder,
        direction: this.appliedDirection,
        include: this.include,
      };
    },
    params() {
      let params = {...this.data, ...this.additionalData};
      if (this.infinite && this.results.length === 0) {
        params.perPage *= params.page;
        params.page = 1;
      }

      return params;
    },
  },
  watch: {
    data() {
      this.fetch();
    }
  },
  mounted() {
    window.addEventListener('popstate', e => {
      this.popState(e.state);
    });

    if (this.fetchOnMount) {
      this.fetch(false, false);
    }
  },
  methods: {
    shouldTrackState(trackState) {
      return trackState && this.trackHistory && !this.skipNextPushState;
    },
    fetch(trackState = true, scrollTop = true) {
      window.App.$emit('grid.fetching', this);

      if (this.shouldTrackState(trackState)) {
        this.pushState();
      }
      if (this.infinite && this.skipNextPushState) { // popping state with infinite loading, remove last N items
        this.results.splice(this.appliedPerPage * this.appliedPage);
        this.skipNextPushState = false;

        return;
      }
      this.skipNextPushState = false;

      window.App.Axios.get(this.endpoint, {params: this.params})
        .then((response) => {
          this.results = this.infinite && this.params.page > 1 ? this.results.concat(response.data.data) : response.data.data;
          this.meta = response.data.meta;
          this.$store.commit('grid/setMeta', response.data.meta);

          if (!this.initialState) {
            this.initialState = {...this.data, meta: this.meta};
          }

          if(! (this.infinite && this.params.page > 1) && scrollTop) { // TODO: improve scrolling
            window.scrollTo(0, window.App.UIkit.util.offset(this.$refs.results.$el).top - 130);
          }

          window.App.$emit('grid.fetched', response.data, this);
        })
        .catch((error) => {
          window.App.$emit('grid.fetch-error', error.response, this);

          window.App.UIkit.notification(error.response.data.message, {status: 'danger', pos: 'top-center'});
        });
    },
    pushState() {
      let data = {...this.data, meta: this.meta};
      let url = window.location.pathname + '?' + window.App.Qs.stringify(this.prepareDataForQueryString({...data}));
      history.pushState(data, url, url);
    },
    popState(state) {
      this.skipNextPushState = true;
      this.$store.commit('grid/setState', state || this.initialState);
    },
    prepareDataForQueryString(data) {
      delete data.include;
      delete data.meta;

      return data;
    },
  },
}



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/assets/js/theme-mixins/DataGrid.js